module.exports = ['$stateProvider', function ($stateProvider) {
    /** Configuro gli endpoint **/
    // $urlRouterProvider.otherwise('/');
}];


//////////////////
// WEBPACK FOOTER
// ./src/gateway/core/configs/StateProvider.js
// module id = 195
// module chunks = 2